"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationStepDto = exports.StepVariantDto = void 0;
/**
 * @deprecated use DTOs from step.dto.ts
 */
class StepVariantDto {
    id;
    _id;
    name;
    uuid;
    _templateId;
    template;
    filters;
    active;
    shouldStopOnFail;
    replyCallback;
    metadata;
}
exports.StepVariantDto = StepVariantDto;
/**
 * @deprecated use DTOs from step.dto.ts
 */
class NotificationStepDto extends StepVariantDto {
    variants;
}
exports.NotificationStepDto = NotificationStepDto;
//# sourceMappingURL=workflow-deprecated.dto.js.map